module.exports = __webpack_public_path__ + "img/simulados-exp-free.884bfbcd.png";